import { Directive, ElementRef, inject, Input, Renderer2 } from '@angular/core';

@Directive({ selector: 'a[phone]' })
export class PhoneDirective {
  private _elementRef = inject(ElementRef);
  private _renderer = inject(Renderer2);

  @Input()
  public set phone(phone: string) {
    if (phone) {
      let cleaned = phone.trim();

      if (!cleaned.startsWith('+')) {
        cleaned = '+' + cleaned;
      }

      this._renderer.setAttribute(
        this._elementRef.nativeElement,
        'href',
        'tel:' + cleaned,
      );
    } else {
      this._renderer.removeAttribute(this._elementRef.nativeElement, 'href');
    }
  }
}
